export const UNIDADES = {
  bandada: {
    id: "bandada", nombre: "Bandada", icono: "🦅",
    color: "#1d4ed8", bg: "#dbeafe", texto: "#1e3a8a",
  },
  manada: {
    id: "manada", nombre: "Manada", icono: "🐺",
    color: "#d97706", bg: "#fef3c7", texto: "#78350f",
  },
  compania: {
    id: "compania", nombre: "Compañía", icono: "⭐",
    color: "#0891b2", bg: "#cffafe", texto: "#164e63",
  },
  tropa: {
    id: "tropa", nombre: "Tropa", icono: "⚜️",
    color: "#16a34a", bg: "#dcfce7", texto: "#14532d",
  },
  avanzada: {
    id: "avanzada", nombre: "Avanzada", icono: "🔷",
    color: "#4338ca", bg: "#e0e7ff", texto: "#312e81",
  },
  clan: {
    id: "clan", nombre: "Clan", icono: "🔥",
    color: "#dc2626", bg: "#fee2e2", texto: "#7f1d1d",
  },
  consejo: {
    id: "consejo", nombre: "Consejo", icono: "🏛️",
    color: "#7c3aed", bg: "#ede9fe", texto: "#4c1d95",
  },
}

export const LISTA_UNIDADES = Object.values(UNIDADES)

// Unidades que usan "unidad" en vez de "etapa" para sus miembros
export const UNIDADES_CON_ROL = ["consejo"]

// Unidades scout para el campo "unidad" en Consejo
export const UNIDADES_SCOUT = [
  { value: "bandada",  label: "Bandada"  },
  { value: "manada",   label: "Manada"   },
  { value: "compania", label: "Compañía" },
  { value: "tropa",    label: "Tropa"    },
  { value: "avanzada", label: "Avanzada" },
  { value: "clan",     label: "Clan"     },
]